import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=6ccbb061&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=6ccbb061&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccbb061",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ccbb061')) {
      api.createRecord('6ccbb061', component.options)
    } else {
      api.reload('6ccbb061', component.options)
    }
    module.hot.accept("./aboutUs.vue?vue&type=template&id=6ccbb061&scoped=true&", function () {
      api.rerender('6ccbb061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUs.vue"
export default component.exports